
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[projectId]/applications/[applicationId]/planting-report/[plantingId]/monitorings",
      function () {
        return require("private-next-pages/projects/[projectId]/applications/[applicationId]/planting-report/[plantingId]/monitorings/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[projectId]/applications/[applicationId]/planting-report/[plantingId]/monitorings"])
      });
    }
  